export enum IRatingLevelSort {
  LEVEL = 'level',
  XP = 'xp',
  COIN = 'coin',
}

export interface IGetCourseRequest {
  categoryId?: number
}
